import { HttpClient } from '@angular/common/http';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { environment, HttpHeadersService } from '@perval/shared';
import { defer, firstValueFrom, map, of } from 'rxjs';

import { FeatureFlag } from '../models/feature-flags.model';
import { FeaturesEnum } from '../enums/feature.enum';

@Injectable({ providedIn: 'root' })
export class FeatureFlagService {
  private readonly mainUrl = `${environment.baseApiUrl}/perval-configuration/api/v1`;

  private readonly platformId = inject(PLATFORM_ID);

  // flags à décommenter lorsqu'on repassera au feature flipping via appel api

  // private readonly flags$ = defer(() =>
  //   from(this.httpHeadersServiceService.getHeadersWithPervalContext()),
  // ).pipe(
  //   switchMap((headers) => {
  //     if (!isPlatformBrowser(this.platformId)) {
  //       return of({} as FeatureFlagsHttp);
  //     }
  //     return this.http.get<FeatureFlagsHttp>(`${this.mainUrl}/features`, {
  //       headers,
  //     });
  //   }),
  //   map((flags) => mapFeatureFlagsResponseToArray(flags) ?? []),
  //   catchError((err) => {
  //     console.error('Erreur flags', err);
  //     return of([] as FeatureFlag[]);
  //   }),
  //   shareReplay({ bufferSize: 1, refCount: false }),
  // );

  private readonly flags$ = defer(() => of(this.buildFlags()));

  constructor(
    private readonly http: HttpClient,
    private readonly httpHeadersServiceService: HttpHeadersService,
  ) {}

  private buildFlags(): FeatureFlag[] {
    return [
      {
        name: FeaturesEnum.INSCRIPTION_AUTONOME,
        enabled: environment.featureFlag.inscriptionAutonomeEnabled === 'true',
      },
    ];
  }

  /** True/false pour un flag */
  hasFlag$(flagName: string) {
    return this.flags$.pipe(
      map((flags) => flags.some((f) => f.name === flagName && f.enabled)),
    );
  }

  /** retourne directement l'objet FeatureFlag */
  getFlag$(flagName: string) {
    return this.flags$.pipe(
      map((flags) => flags.find((f) => f.name === flagName)),
    );
  }

  /** Init doit maintenant refléter le type réel */
  init(): Promise<FeatureFlag[]> {
    return firstValueFrom(this.flags$);
  }
}
